export const categories = [
  { id: 1, name: '全部', slug: 'all', icon: 'ri-apps-2-line', color: 'primary' },
  { id: 2, name: '恋爱', slug: 'romance', icon: 'ri-heart-line', color: 'primary' },
  { id: 3, name: '动作', slug: 'action', icon: 'ri-fire-line', color: 'accent' },
  { id: 4, name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', color: 'accent' },
  { id: 5, name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', color: 'secondary' },
  { id: 6, name: '悬疑', slug: 'thriller', icon: 'ri-spy-line', color: 'secondary' },
  { id: 7, name: '治愈', slug: 'healing', icon: 'ri-plant-line', color: 'primary' },
  { id: 8, name: '剧情', slug: 'drama', icon: 'ri-movie-2-line', color: 'accent' },
];